import { useCallback, useState } from 'react';

export function useRadarControls() {
  const [radarEnabled, setRadarEnabled] = useState<boolean>(false);
  const [radarFuture, setRadarFuture] = useState<boolean>(false);

  const enableRadar = useCallback((futureRainfall: boolean) => {
    setRadarFuture(futureRainfall);
    setRadarEnabled(true);
  }, []);

  const disableRadar = useCallback(() => {
    setRadarEnabled(false);
  }, []);

  return { radarEnabled, radarFuture, enableRadar, disableRadar, setRadarFuture };
}
